import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Sobre from '../views/Sobre.vue'
import Contato from '../views/Contato.vue'
import Login from '../views/Auth/Login.vue'
import Register from '../views/Auth/Register.vue'
import AdminHome from '../views/admin/Home.vue'
import Dashboard from '../views/admin/Dashboard.vue'
import Barbeiros from '../views/admin/Barbeiros.vue'
import Funcoes from '../views/admin/Funcoes.vue'
import Agenda from '../views/admin/Agenda.vue'
import Feriados from '../views/admin/Feriados.vue'
import Mensagem from '../views/admin/Mensagem.vue'
import Fotos from '../views/admin/Fotos.vue'
import Configuracoes from '../views/admin/Configuracoes.vue'
import Fidelidade from '../views/admin/Fidelidade.vue'
import Financeiro from '../views/admin/Financeiro.vue'
import Teste from '../views/admin/Teste.vue'



import store from '../store/index'
//import {auth} from '../../firebaseConfig'


Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
   
  },
  {
    path: '/sobre',
    name: 'Sobre',
    component: Sobre,
   

  },
  {
    path: '/contato',
    name: 'Contato',
    component: Contato,
   

  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  
  },
  {
    path: '/admin/home',
    name: 'AdminHome',
    component: AdminHome,
    meta: {
      requiresAuth: true,
      requiresLevel: true,

     
    }
  },
  {
    path: '/admin/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true
    },
  },

  {
    path: '/admin/barbeiros',
    name: 'Barbeiros',
    component: Barbeiros,
    meta: {
      requiresAuth: true,
      requiresLevel: true,
    },
  },
  {
    path: '/admin/funcoes',
    name: 'Funcoes',
    component: Funcoes,
    meta: {
      requiresAuth: true,
      requiresLevel: true,

    },
  },
  {
    path: '/admin/agenda',
    name: 'Agenda',
    component: Agenda,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/admin/mensagens',
    name: 'Mensagens',
    component: Mensagem,
    meta: {
      requiresAuth: true,
      requiresLevel: true,

    },
  },
  {
    path: '/admin/feriados',
    name: 'Feriados',
    component: Feriados,
    meta: {
      requiresAuth: true,
      requiresLevel: true,

    },
  },
  {
    path: '/admin/fotos',
    name: 'Fotos',
    component: Fotos,
    meta: {
      requiresAuth: true,
      requiresLevel: true,

    },
  },
  {
    path: '/admin/configuracoes',
    name: 'Configuracoes',
    component: Configuracoes,
    meta: {
      requiresAuth: true,
      requiresLevel: true,

    },
  },
  {
    path: '/admin/fidelidade',
    name: 'Fidelidade',
    component: Fidelidade,
    meta: {
      requiresAuth: true,
      requiresLevel: true,

    },
  },
  {
    path: '/admin/financeiro',
    name: 'Financeiro',
    component: Financeiro,
    meta: {
      requiresAuth: true,
      requiresLevel: true,
      nivelMinimo: 5,

    },
  },
  {
    path: '/admin/teste',
    name: 'Teste',
    component: Teste,
    meta: {
      requiresAuth: false,
      requiresLevel: false,

    },
  },
  /*
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },*/
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


function decidirRota(to, next){
  if (!to.meta.requiresAuth) {
    next()
    return
  }

  if(!store.getters.isUserAuth){
    console.log("redirecionando p login")
    // Guarda de onde veio para o login devolver o usuário ao destino.
    next({ path: "/login", query: { redirect: to.fullPath } })
    return
  }

  if (!to.meta.requiresLevel){
    console.log("mandando adiante")
    next()
    return
  }

  // BUG VUEX -> POR ALGUMA RAZÃO PRECISO ACESSAR STATE.{MODULO} ANTES DE USAR OS GETTERS...
  let permissao = store.state.authUser.permissoes[store.state.authUser.userLvl]

  // Sem nivelMinimo na rota vale o padrão de sempre (acima de 2).
  // O controle financeiro usa nivelMinimo 5.
  let nivelMinimo = to.meta.nivelMinimo || 3

  if(permissao >= nivelMinimo){
    console.log("mandando adiante pelo level")
    next()
  }else{
    console.log("nivel insuficiente, voltando para a agenda")
    next("/admin/agenda")
  }
}

router.beforeEach((to, from, next) => {
  // Espera a restauração da sessão antes de decidir. Sem isso, um F5 em rota
  // protegida é avaliado com o Vuex ainda vazio e cai no login.
  // A ação é idempotente: depois da primeira vez resolve na hora.
  // Os dois argumentos do then (sucesso e falha) garantem que decidirRota roda
  // uma única vez — com .catch encadeado, um erro dentro dela chamaria next() duas vezes.
  const decidir = () => decidirRota(to, next)
  store.dispatch('checkLoggedIn').then(decidir, decidir)

  
  

  
 
})
export default router
